import config from './config';

// eslint-disable-next-line
__webpack_public_path__ = config.publicPath;
